"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./SelectField.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Our main component
var SelectField = function SelectField(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectField ".concat(props.className, " ").concat(props.disabled ? 'disabled' : '', " ").concat(props.template ? "temp_".concat(props.template) : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectFieldSelected"
  }, props.active ? props.active : 'Select', /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "ArrowFillDown"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectFieldOptions"
  }, props.options && props.options.map(function (value, index) {
    return value && /*#__PURE__*/_react["default"].createElement("div", {
      className: "selectFieldOption",
      key: index,
      onClick: function onClick() {
        return props.onChange ? props.onChange(value) : undefined;
      }
    }, _typeof(value) === 'object' ? Object.entries(value).map(function (_ref, index) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return key !== 'id' && /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, value);
    }) : value);
  })));
};

var _default = SelectField;
exports["default"] = _default;